import React from 'react'
import { Main } from './components'

const Products = () => <Main />

export default Products
